import { configureStore, combineReducers } from '@reduxjs/toolkit';
import favoritesReducer from './favoritesSlice';
import gamesReducer from './gamesSlice';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('gameStore');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('gameStore', serializedState);
  } catch (err) {}
};

const rootReducer = combineReducers({
  favorites: favoritesReducer,
  games: gamesReducer,
});

const preloadedState = loadState();

export const store = configureStore({
  reducer: rootReducer,
  preloadedState,
});

store.subscribe(() => {
  saveState({
    favorites: store.getState().favorites,
  });
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;